module.exports = __webpack_public_path__ + "img/In-Patient Care.2cd98faa.png";